import { render, staticRenderFns } from "./student-list-hour.vue?vue&type=template&id=62b04976&scoped=true&"
import script from "./student-list-hour.vue?vue&type=script&lang=js&"
export * from "./student-list-hour.vue?vue&type=script&lang=js&"
import style0 from "./student-list-hour.vue?vue&type=style&index=0&id=62b04976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b04976",
  null
  
)

export default component.exports